import { render, staticRenderFns } from "./MulticartModal.vue?vue&type=template&id=3fefb8f8&scoped=true"
import script from "./MulticartModal.vue?vue&type=script&lang=js"
export * from "./MulticartModal.vue?vue&type=script&lang=js"
import style0 from "./MulticartModal.vue?vue&type=style&index=0&id=3fefb8f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fefb8f8",
  null
  
)

export default component.exports